export default __webpack_public_path__ + "267c48326f40c079e64a204a47c2925a.png";